module.exports = __webpack_public_path__ + "7c8ca26d31d3144adae919d7cc60834c.svg";